import { connect }               from 'react-redux';
import Faqs                      from './faqs.jsx';
import Locale                    from '../../../locale';
import getActivationFieldsString from './get-activation-fields-string';

export default connect(
    // mapStateToProps
    ( state ) => {
        const activationFields = state.clientData.clientBranding.activationFields;
        const locale = state.userData.locale;
        const verificationFieldLabel = getActivationFieldsString( activationFields, locale.code );

        return {
            userIdLabel: Locale.getString( state, 'common.input.usernameLabel' ),
            verificationFieldLabel
        };
    },
    // mapDispatchToProps
    {}
)( Faqs );
